// Keep in sync with resources/sass/_variables.scss

export const styles = {
  white900: '#FFFFFF',
  white800: '#DEDEDE',
  white700: '#B2B2B2',
  level0BgNoGradient: 'rgb(6, 6, 6)',
  level1BgNoGradient: '#141414',
  level2BgNoGradient: '#242424FF',
  level2BgNoGradientTransparent: '#24242400',
  level0Border: '#242424',
  level1Border: '#242424',
  level2Border: '#404040',
  tinyGap: 4,
  smallerGap: 8,
  smallGap: 12,
};
